import { BroadcastChannel as BC } from 'broadcast-channel';
export const BroadCastChannel = {
    sender: (key, data) => {
        const bc_sender = new BC(key);
        bc_sender.postMessage(data);
    }
}